module.exports = __webpack_public_path__ + "img/crow-no.66ecefa.png";